import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useJobProspectsStatsState() {
  return useAppState();
}

export function useJobProspectsStatsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      stats: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  return {
    initializeState,
    onResponse,
    onError,
  };
}
